let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("1KyrT"), load("9mjQR"), load("lhkXg"), load("fgNp8")]).then(() => parcelRequire('6ncRx'));